/**
 * @file Manages site header events.
 */
((Drupal) => {
  class SiteWideHeader {
    constructor() {
      this.initialize();
    }

    closeOnScape(event) {
      if (event.key === "Escape") {
        document.querySelectorAll(".menu_link_content.show").forEach((item) => {
          item.parentElement.classList.remove("active");
          item.parentElement.querySelector(".menu-item__trigger").attributes[
            "aria-expanded"
          ].value = "false";
          item.classList.remove("show");
        });

        // Move the focus to the trigger button
        document.querySelector(".menu-item__trigger").focus();
      }
    }

    toggleMenu(event) {
      const trigger = event.target;
      const parent = trigger.parentElement;
      const menuLinkContent = parent.querySelector(".menu_link_content");

      const isDesktopMenu = menuLinkContent?.closest(
        ".site-wide-header__main-menu-area__desktop"
      );

      const isMenuToggle = trigger.classList.contains(
        "site-wide-header__menu-toggle"
      );

      const isOpen = menuLinkContent.classList.contains("show");

      // Toggle menu state
      trigger.setAttribute("aria-expanded", String(!isOpen));
      parent.classList.toggle("active", !isOpen);
      menuLinkContent.classList.toggle("show", !isOpen);

      // ===== SECOND ADDITION (DESKTOP MENUS ONLY) =====
      if (isDesktopMenu) {
        document.body.classList.toggle("menu-open", !isOpen);
        document.documentElement.classList.toggle("menu-open", !isOpen);
      }

      // Close other open menus
      document.querySelectorAll(".menu_link_content.show").forEach((item) => {
        if (item !== menuLinkContent) {
          item.parentElement.classList.remove("active");
          item.parentElement
            .querySelector(".menu-item__trigger")
            ?.setAttribute("aria-expanded", "false");
          item.classList.remove("show");
        }
      });

      // Close search toggle if open
      const searchToggle = document.querySelector(
        '.site-wide-header__search-toggle[aria-expanded="true"]'
      );
      if (searchToggle) {
        searchToggle.setAttribute("aria-expanded", "false");
      }

      const searchArea = document.querySelector(
        ".site-wide-header__search-area"
      );
      if (searchArea) {
        searchArea.classList.remove("show");
      }

      window.onclick = function(event) {
        if (!event.target.matches('.menu-item__trigger')) {
          if (!event.target.closest('.menu_link_content.show')) {
            document.querySelectorAll(".menu_link_content.show").forEach((item) => {
              item.parentElement.classList.remove("active");
              item.parentElement.querySelector(".menu-item__trigger").attributes[
                "aria-expanded"
              ].value = "false";
              item.classList.remove("show");
            });
            if (isDesktopMenu) {
              document.body.classList.remove("menu-open");
              document.documentElement.classList.remove("menu-open");
            }
            // Move the focus to the trigger button
            document.querySelector(".menu-item__trigger").focus();
          }
        }   
      }

    }

  


    openMobileMenu(event) {
      const searchArea = document.querySelector(
        ".site-wide-header__search-area"
      );
      const searchAreaBtn = document.querySelector(
        ".site-wide-header__search-toggle"
      );
      const mobileMenu = document.querySelector(
        ".site-wide-header__main-menu-area"
      );

      const isOpen = mobileMenu.classList.contains("show");

      // Close search if opening menu
      if (!isOpen) {
        searchArea.classList.remove("show");
        searchAreaBtn.setAttribute("aria-expanded", "false");
      }

      // Toggle menu
      mobileMenu.classList.toggle("show");
      event.target.setAttribute("aria-expanded", String(!isOpen));

      // ✅ FIRST ADDITION (CORRECT PLACE)
      document.body.classList.toggle("menu-open", !isOpen);
      document.documentElement.classList.toggle("menu-open", !isOpen);
    }

    toggleUtilityMenu(event) {
      const button = event.srcElement;
      button.setAttribute(
        "aria-expanded",
        button.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
      document
        .querySelectorAll(
          '.site-wide-header__utility-trigger[aria-expanded="true"]'
        )
        .forEach((item) => {
          if (item !== button) {
            item.setAttribute("aria-expanded", "false");
            item.nextElementSibling.classList.remove("open");
          }
        });
      if (button.nextElementSibling) {
        button.nextElementSibling.classList.toggle("open");
      }

      // Close if clicked outside
      document.addEventListener("click", function (e) {
        if (
          !button.nextElementSibling.contains(e.target) &&
          !button.contains(e.target)
        ) {
          button.setAttribute("aria-expanded", "false");
          button.nextElementSibling.classList.remove("open");
        }
      });
    }

    initialize() {
      if (this.initialized) {
        return;
      }
      const mainMenuTriggers = document.querySelectorAll(".menu-item__trigger");
      const mobileMenuTrigger = document.querySelector(
        ".site-wide-header__menu-toggle"
      );
      const utilityMenuTriggers = document.querySelectorAll(
        ".site-wide-header__utility-trigger"
      );
      if (
        mobileMenuTrigger &&
        !mobileMenuTrigger.classList.contains("initialized")
      ) {
        mobileMenuTrigger.addEventListener(
          "click",
          this.openMobileMenu.bind(this)
        );
        mobileMenuTrigger.classList.add("initialized");
      }
      if (mainMenuTriggers.length) {
        mainMenuTriggers.forEach((trigger) => {
          if (trigger.classList.contains("initialized")) {
            return;
          }
          trigger.addEventListener("click", this.toggleMenu.bind(this));
          trigger.classList.add("initialized");
        });
      }
      if (utilityMenuTriggers.length) {
        utilityMenuTriggers.forEach((trigger) => {
          if (trigger.classList.contains("initialized")) {
            return;
          }
          trigger.addEventListener("click", this.toggleUtilityMenu.bind(this));
          trigger.classList.add("initialized");
        });
      }

      this.initialized = true;
    }
  }

  Drupal.behaviors.siteWideHeader = {
    attach: function (context, settings) {
      if (document !== context) {
        return;
      }

      new SiteWideHeader();
    },
  };
})(Drupal);
